<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>PVI Markets</strong>
        </div>
        <b-row>
          <b-col class="col-lg-12 col-xl-12 my-0" v-if="pviMkttotalRows > 49">
            <b-alert variant="warning" show>You are not able to add any more markets. You have achieved the market limit!</b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-lg-12 col-xl-9 my-0">
            <div style="height: 68vh; overflow: auto">

              <b-card>
                <template v-slot:header>
                  <strong>Markets for Calculating Average</strong>
                </template>
                <template>
                  <b-row>
                    <b-col class="col-6 pb-2">
                      <b-input-group>
                        <b-form-input id="inpSearch" v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                          <b-btn id="btnClear" :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col class="col-6">
                      <b-button id="btnAdd" class="pull-right" variant="outline-success" @click="addMarket" title="Add">
                        <i class="fa fa-plus-square"></i> <strong>Add</strong>
                      </b-button>
                    </b-col>

                  </b-row>
                </template>
                <b-table :items="pvimarkets" :fields="pviMarketfields" head-variant="light" sticky-header bordered small caption-top responsive stacked="md"
                         :current-page="pviMktcurrentPage" :per-page="pviMktperPage" show-empty
                         :filter="filter" @filtered="onFiltered"> 

                  <template v-slot:cell(State)="data">
                    <slot>{{data.item.StateName}}</slot>
                  </template>
                  <template v-slot:cell(Market)="data">
                    <slot v-if="!data.item.edit">{{data.item.Market}}</slot>
                    <b-form-input v-if="data.item.edit" v-model="data.item.Market" maxlength="50"
                                  v-bind:class="{'is-invalid': validateErrors.has('editMarket') }" v-validate="{required: true}" name="editMarket" />
                  </template>
                  <template v-slot:cell(RegionID)="data">
                    <slot v-if="!data.item.edit">{{data.item.RegionName}}</slot>
                    <b-form-select id="selRegion" v-if="data.item.edit" v-model="data.item.RegionID" :options="data.item.RegionOptions"
                                   value-field="RegionID" text-field="RegionName" name="Region" />
                  </template>
                  <template v-slot:cell(ZIP)="data">
                    <slot>{{data.item.ZIP}}</slot>
                  </template>
                  <template #cell(actions)="data">
                    <button id="btnEdit" class="btn btn-primary text-white mx-1" v-if="!data.item.edit" @click="Edit(data.item)" title="Edit">
                      <i class="fa fa-edit"><strong> Edit</strong></i>
                    </button>
                    <button id="btnDelete" class="btn btn-danger mx-1" v-if="!data.item.edit" @click="Delete(data.item)" title="Delete">
                      <i class="fa fa-trash"><strong> Delete</strong></i>
                    </button>
                    <button id="btnSave" class="btn btn-success text-white mx-1" v-if="data.item.edit" @click="Save(data.item)" title="Save">
                      <i class="fa fa-save"><strong> Save</strong></i>
                    </button>
                    <button id="btnCancel" class="btn btn-info text-white mx-1" v-if="data.item.edit" @click="Cancel(data.item)" title="Cancel">
                      <i class="fa fa-close"><strong> Cancel</strong></i>
                    </button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="pviMkttotalRows" :per-page="pviMktperPage" v-model="pviMktcurrentPage" prev-text="Prev" next-text="Next" />
                </nav>
              </b-card>

            </div>
          </b-col>
          <b-col class="col-lg-12 col-xl-3" v-if="initLoad">
            <div class="col-lg-7 offset-lg-2" style="text-align: center; height: 100%; opacity: 0.7; filter: alpha(opacity=70);">
              <div style="text-align: right; margin-top: calc(50vh - 250px);">
                <img src="/web/img/pvi-logo-sm.png" alt="PVI Logo" class="img-fluid">
                <h4 style="margin-right: 2rem !important;">State of the Art Analysis for Lenders.</h4>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <b-modal ref="addMarketModal" size="md" title="Add Market" id="addMarketModal"
             header-bg-variant="dark" header-text-variant="light" static
             ok-title="Add" @ok="modalOK($event)" @cancel="modalCancel($event)">
      <b-container fluid>
        <b-row class="mb-1">
          <b-col class="text-right pt-2" cols="4">ZIP</b-col>
          <b-col>
            <b-form-input id="inpZipModal" v-model="newMarket.ZIP" name="ZIP" maxlength="5" @blur="getMarketByZIP($event)"
                          v-bind:class="{'is-invalid': validateErrors.has('ZIP') }" v-validate="{required: true}" />
            <em class="error invalid-feedback">{{ validateErrors.first('ZIP') }}</em>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right pt-2" cols="4">Market</b-col>
          <b-col class="pull-left">
            <b-form-input id="inpMarketModal" v-model="newMarket.Market" maxlength="50" name="Market"
                          v-bind:class="{'is-invalid': validateErrors.has('Market') }" v-validate="{required: true}" />
            <em class="error invalid-feedback">{{ validateErrors.first('Market') }}</em>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right pt-2" cols="4">Region</b-col>
          <b-col class="pull-left">
            <b-form-select id="selRegionModal" v-model="newMarket.RegionID" :options="newMarket.RegionOptions"
                           value-field="RegionID" text-field="RegionName" name="Region" />
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col class="text-right pt-2" cols="4">State</b-col>
          <b-col>
            <b-form-input id="inpStateModal" v-model="newMarket.StateName" maxlength="50" name="State" plaintext
                          v-bind:class="{'is-invalid': validateErrors.has('State') }" v-validate="{required: true}" />
            <em class="error invalid-feedback">{{ validateErrors.first('State') }}</em>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

      <loading :show="boolLoading" :label="txtLoading">
      </loading>
    </div>
  </template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import Store from '@/store'
import { confirm, alert } from 'devextreme/ui/dialog'
import notify from 'devextreme/ui/notify'

export default {
  name: 'PVIMarkets',
  components: {
    loading
  },
  created () {
    this.initLoad = true
    let self = this
    self.newMarket = Object.assign(self.newMarket, self.blankMarket)
    self.loadMarkets()
  },
  data () {
    return {
      errMsg: '',
      initLoad: true,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      changesSaved: true,
      editCount: 0,
      isInternalStaff: Store.state.isInternalStaff,
      blankMarket: { StateCode: '', StateName: '', RegionID: 0, RegionName: '', Market: '', ZIP: '', edit: false, RegionOptions: [], currentZIP: null },
      newMarket: {},
      pvimarkets: [],
      pviMarketfields: [    
        { key: 'index', label: '#', sortable: true },
        { key: 'StateName', label: 'State', sortable: true, tdClass: 'w200' },
        { key: 'Market', label: 'Market', sortable: true, tdClass: 'w200' },
        { key: 'RegionID', label: 'Region', sortable: false, tdClass: 'w200' },
        { key: 'ZIP', label: 'ZIP', sortable: true },
        { key: 'actions', label: 'Actions', tdClass: 'w160' }
      ],
      pviMktcurrentPage: 1,
      pviMktperPage: 10,
      pviMkttotalRows: 0,
      filter: null,
      newMarketZIP: ''
    }
  },
  methods: {
    loadMarkets () {
      let self = this
      axios.get('/api/pvi/getpvimarkets')
        .then(response => {
          if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
            if (response.data !== undefined) {
              // console.log(`loadPVIReportSettings ${JSON.stringify(response)}`)
              var i = 0;
              self.pvimarkets = response.data.map(x => {
                i = i + 1;
                x['index'] = i;
                x['edit'] = false
                x['currentZIP'] = null
                return x
              })
              self.pviMkttotalRows = response.data.length
            }
          }
          self.initLoad = false
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    addMarket () {
      this.resetModal()
      this.$refs.addMarketModal.show()
    },
    async getMarketByZIP (e) {
      this.newMarketZIP = this.newMarket.ZIP
      await this.getRegionsByZIP(this.newMarket, true)
    },
    async getRegionsByZIP (editMarket, isnew) {
      // console.log(`getmarketbyzip editMarket: ${JSON.stringify(editMarket)}`)
      var self = this
      if (editMarket.ZIP === null || editMarket.ZIP === undefined || editMarket.ZIP.length < 5) return
      if (editMarket.currentZIP !== null && editMarket.currentZIP === editMarket.ZIP) return

      var obj = {
        ZIP: editMarket.ZIP
      }

      try {
        self.boolLoading = true
        let response = await axios.post('/api/pvi/getmarketbyzip', obj)

        //    console.log(`getmarketbyzip ${JSON.stringify(response.data)}`)
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined && response.data !== null) {
            if (isnew) {
              editMarket = Object.assign(editMarket, response.data)
            } else {
              editMarket.RegionOptions = response.data.RegionOptions
              // console.log(`getmarketbyzip editMarket ${JSON.stringify(editMarket)}`)
              if ((editMarket.RegionID === null || editMarket.RegionID === 0) && editMarket.RegionOptions.length === 1) {
                editMarket.RegionID = editMarket.RegionOptions[0].RegionID
                editMarket.RegionName = editMarket.RegionOptions[0].RegionName
              }
              editMarket.originalMarket = editMarket.Market
            }
            editMarket.currentZIP = editMarket.ZIP
            editMarket.edit = true
            self.changesSaved = false
            self.editCount = this.editCount + 1
          }
        }
        self.boolLoading = false
      } catch (error) { // console.log(`getmarketbyzip1 error : ${JSON.stringify(error)}`)
        self.SetErrorMsg(error, 'get market by zip')
      }
    },
    modalOK (arg) {
      // arg.preventDefault()

      var self = this
      Promise.all([
        this.$validator.validate('ZIP', self.newMarket.ZIP),
        this.$validator.validate('Market', self.newMarket.Market),
        this.$validator.validate('State', self.newMarket.StateCode)
      ]).then(values => {
        if (values.every(value => { return value })) {
          // self.$refs.addMarketModal.hide()
          self.boolLoading = true
          // console.log(JSON.stringify(self.newMarket))
          axios.post('/api/pvi/savepvimarket', self.newMarket)
            .then(response => {
              self.boolLoading = false
              self.resetModal()
              self.loadMarkets()
              self.editCount = 0
              self.changesSaved = self.editCount === 0
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }

      })
    },
    modalCancel (arg) {
      // arg.preventDefault()
      var self = this
      self.resetModal()
      if (parseInt(self.editCount) > 0)
        self.editCount = self.editCount - 1
      self.changesSaved = self.editCount === 0
      // self.$refs.addMarketModal.hide()
    },
    resetModal () {
      var self = this
      self.newMarket = Object.assign(self.newMarket, self.blankMarket)
      // this dummy property is required to clear the modal in browser
      self.newMarketZIP = ''
      // console.log(`resetModal : ${JSON.stringify(self.newMarket)}`)
      self.validateErrors.clear()
    },
    async Edit (item) {
      if (item.currentZIP === null || item.currentZIP !== item.ZIP) {
        await this.getRegionsByZIP(item, false)
      } else {
        item.edit = true
        // item.originalState = item.State
        // item.originalstatename = item.statename
        item.originalMarket = item.Market
        this.changesSaved = false
        this.editCount = this.editCount + 1
      }
    },
    Cancel (item) {
      item.edit = false
      // item.State = item.originalState
      // item.statename = item.originalstatename
      item.Market = item.originalMarket
      if (parseInt(self.editCount) > 0)
        this.editCount = this.editCount - 1
      this.changesSaved = self.editCount === 0
    },
    Save (item) {
      var self = this
      Promise.all([
        this.$validator.validate('editMarket', item.Market)
      ]).then(values => {
        if (values.every(value => { return value })) {
          self.boolLoading = true
          if (item.RegionID !== null && item.RegionID > 0 && item.RegionOptions.length > 0) {
            item.RegionName = item.RegionOptions.filter(r => r.RegionID === item.RegionID)[0].RegionName
          }

          // console.log(`savepvimarket ${JSON.stringify(item)}`)
          axios.post('/api/pvi/savepvimarket', item)
            .then(response => {
              self.boolLoading = false
              item.edit = false
              if (parseInt(self.editCount) > 0)
                self.editCount = self.editCount - 1
              self.changesSaved = self.editCount === 0
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    Delete (item) {
      var self = this
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/pvi/deletepvimarket', item)
            .then(response => {
              self.boolLoading = false
              notify('Market has been deleted', 'success', 3500)
              self.loadMarkets()
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    SetErrorMsg (error, action) {
      var self = this

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

      self.boolLoading = false

      self.errMsg = 'There was an error ' + action + ' your changes : '
      if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
        self.errMsg = self.errMsg + error.response.data
      } else {
        self.errMsg = self.errMsg + error
      }

      self.dismissibleType = 'danger'
      self.showDismissibleAlert = true

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') !== -1) {
        self.errMsg = error.response.statusText.replace('403.1', '')
      }
    },

    onFiltered (filteredItems) {
      this.pviMkttotalRows = filteredItems.length
      this.pviMktcurrentPage = 1
    }
  },
  computed: {},
  watch: {},
  beforeDestroy: function () { },
  beforeRouteLeave (to, from, next) {
    // console.log(`${from} -> ${to}`)
    if (!this.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    } else {
      return next()
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>
  <style>
    .table > tbody > tr > td {
      vertical-align: middle !important;
    }
    .w160 {
      min-width: 160px;
    }

    .w200 {
      min-width: 200px;
    }

  </style>



// WEBPACK FOOTER //
// src/views/PVIMarkets.vue